import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './app-config.interface';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private config: AppConfig;

  constructor(private http: HttpClient) { }

  loadConfig(): Promise<AppConfig> {
    console.log('loadConfig');
    return firstValueFrom(this.http.get<AppConfig>('../app-config.json'))
      .then((data) => {
        this.config = data;
        console.log('Config Loaded:', data);
        return data;
      })
      .catch((error) => {
        console.error('Error loading config:', error);
        throw error; // Rethrow the error for further handling
      });
  }

  getConfiguration(): AppConfig {
    return this.config;
  }

  getBaseApiUrl(): string {
    return this.config.apiUrl;
  }
}
